import {
  showMessage,
  stringToHTML,
  debounce,
  getResponseByMode
} from './utils';

export const deliveryData = {
  init: function () {
    this._deliveryContainer = document.querySelector('.product-delivery__table');
    this._productId = document.querySelector('#product_id').value;
    this._dateContainer = document.querySelector('.stock__delivery');
    this._data = null;
    this._load = debounce(this._load.bind(this));
    if (this._deliveryContainer || this._dateContainer) {
      this._load();
    }
  },

  _load: async function () {
    try {
      const mock = 'mocks/delivery-table.html';
      const real = window.location.origin + `/index.php?option=com_jshopping&controller=product&task=getShipping&product_id=${this._productId}`;
      const url = getResponseByMode(mock, real);

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Неуспешный запрос');
      }
      const html = await response.text();
      const doc = stringToHTML(html);
      this._data = doc;
      this._insertTable();

      if (this._dateContainer) {
        this._insertDate();
      }

    } catch (error) {
      showMessage(error.message);
    }
  },

  _insertTable: function () {
    const deliveryList = this._data.querySelector('#table');
    this._deliveryContainer.append(deliveryList);
  },

  _insertDate: function () {
    const date = this._data.querySelector('#date').textContent;
    this._dateContainer.textContent = 'Доставим к ' + date;
  }
};
